module.exports = __webpack_public_path__ + "static/media/pmv_blue_filled.350b32bb.svg";